/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { Tab } from 'cio/utils/tabs';

interface TabStripArgs {
  tabs: Tab[];
  selectedValue: string;
  onSelect: (value: string) => unknown;
}

export default class TabStrip extends Component<TabStripArgs> {
  @action
  selectTab(tab: Tab) {
    if (tab.disabled) {
      return;
    }

    this.args.onSelect(tab.value);
  }
}
